export default "__VITE_ASSET__D5AMyF14__"